module.exports = __webpack_public_path__ + "media/images/guest-room-be3ed636.jpg";